<script>

import CommonService from '../../services/common';
import Dropdown from 'primevue/dropdown';


export default {
    components: { Dropdown },
    props: ['field', 'value', 'disabled', 'api', 'format', 'sortField', 'staticOptions'],
    data(){
        return {
           options : [],
        //    filteredOptions: []
        }
    },
    mounted(){
        this.loadOptions();
    },
    methods: {
        loadOptions(){
            if(this.api){
                let params = {}
                
                if(this.sortField){
                    params = {
                        sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                    };
                }

                CommonService.loadGeneric(this.api, params, response => {
                    if(response.success){
                        this.options = [];
                        this.options.push(...response.data);

                        // this.filteredOptions = [];
                        // this.filteredOptions.push(...response.data.data);
                    }
                });
            }else{
                this.options = this.staticOptions;
                // this.filteredOptions = this.staticOptions;
            }
        },
        // filter(event){
        //     if (!event.query.trim().length) {
        //         this.filteredOptions = [...this.options];
        //     }
        //     else {
        //         this.filteredOptions = this.options.filter((item) => {
        //             return item[this.format.label].toLowerCase().startsWith(event.query.toLowerCase());
        //         });
        //     }
        // },
        itemSelect(){
            console.log(arguments);
        }
    }
}


</script>


<template>
    <Dropdown :options="options" :filter="true" :optionLabel="format?.label" :optionValue="format?.value" :disabled="this.disabled" showClear/>
</template>